import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useShow } from "@/contexts/ShowContext"
import { apiFetch } from "@/lib/api"
import AssetsEditor from "@/components/AssetsEditor"
import Loader from "@/components/loader"

export default function CharacterAssetsPage() {
    const { show } = useShow()
    const { characterId } = useParams()
    const [character, setCharacter] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        let active = true
        const fetchCharacter = async () => {
            setLoading(true)
            try {
                const response = await apiFetch(`/api/shows/${show._id}/characters/${characterId}`)
                if (!response.ok) throw new Error('Failed to fetch character')
                const data = await response.json()
                if (active) setCharacter(data)
            } catch (err) {
                if (active) setError(err.message)
            } finally {
                if (active) setLoading(false)
            }
        }
        fetchCharacter()
        return () => { active = false }
    }, [show._id, characterId])

    if (loading) return <Loader />

    if (error) {
        return (
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                <span className="text-red-400">Error: {error}</span>
            </div>
        )
    }

    return (
        <AssetsEditor
            characterId={characterId}
            subtitle={character?.name}
            allowCreateFolder={false}
            allowCreateAsset={false}
            allowAssignCharacters={false}
            allowMove={false}
            allowDuplicate={false}
        />
    )
}
